import { resolveUrl } from "../../../utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export async function toggleNotifications(
  data: { parent: string; parentEnabled: boolean } | { child: string; childEnabled: boolean },
) {
  const url = resolveUrl(`/notifications/settings/update`);

  const response = await fetch(url, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return await response.json();
}
